var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "calendar",
      class: { mobile: _vm.isMobile },
      attrs: { dir: "rtl" },
    },
    [
      _c("div", { staticClass: "calendar-header" }, [
        _c("div", { staticClass: "nav-month" }, [
          _c(
            "button",
            {
              staticClass: "nav-btn",
              attrs: {
                type: "button",
                "aria-label": "חודש קודם",
                disabled: !_vm.canGoPrev,
              },
              on: { click: _vm.prevMonth },
            },
            [_vm._v("‹")]
          ),
          _c("span", { staticClass: "month-year" }, [
            _vm._v(_vm._s(_vm.monthLabel) + " " + _vm._s(_vm.displayYear)),
          ]),
          _c(
            "button",
            {
              staticClass: "nav-btn",
              attrs: {
                type: "button",
                "aria-label": "חודש הבא",
                disabled: !_vm.canGoNext,
              },
              on: { click: _vm.nextMonth },
            },
            [_vm._v("›")]
          ),
        ]),
        _c("div", { staticClass: "legend" }, [
          _c("div", { staticClass: "legend-item" }, [
            _c(
              "svg",
              { attrs: { width: "8", height: "8", viewBox: "0 0 8 8" } },
              [
                _c("circle", {
                  attrs: {
                    cx: "4",
                    cy: "4",
                    r: "4",
                    fill: "rgba(23, 67, 122, 0.44)",
                  },
                }),
              ]
            ),
            _c("span", [_vm._v("יום לימודים רגיל")]),
          ]),
          _c("div", { staticClass: "legend-item" }, [
            _c(
              "svg",
              { attrs: { width: "8", height: "8", viewBox: "0 0 8 8" } },
              [
                _c("circle", {
                  attrs: { cx: "4", cy: "4", r: "4", fill: "#FFC56F" },
                }),
              ]
            ),
            _c("span", [_vm._v("יום חג/שבתון")]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "weekdays" },
        _vm._l(_vm.weekDayNames, function (d) {
          return _c("span", { key: d, staticClass: "weekday" }, [
            _vm._v(_vm._s(d)),
          ])
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "days-grid" },
        _vm._l(_vm.calendarCells, function (cell) {
          return _c(
            "div",
            {
              key: cell.key,
              staticClass: "day-cell",
              class: {
                other: cell.other,
                today: cell.isToday,
                holiday: cell.isHoliday,
                "evening-holiday": cell.isEveningHoliday,
                empty: cell.isEmpty,
                past: cell.isPast,
                locked: cell.isLocked,
                "after-max": cell.isAfterMax,
              },
            },
            [
              cell.day
                ? [
                    _c("div", { staticClass: "day-header-row" }, [
                      _c("span", { staticClass: "day-num" }, [
                        _vm._v(_vm._s(cell.day)),
                      ]),
                      cell.isHoliday
                        ? _c("span", { staticClass: "holiday-name" }, [
                            _vm._v(_vm._s(cell.holidayName)),
                          ])
                        : _vm._e(),
                    ]),
                    _c(
                      "div",
                      { staticClass: "cell-body-center" },
                      [
                        _vm._t(
                          "cell-body",
                          function () {
                            return [
                              _c("div", { staticClass: "hours-control" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "hour-btn increase",
                                    attrs: {
                                      type: "button",
                                      "aria-label": "הוסף שעות",
                                      disabled:
                                        cell.isPast ||
                                        cell.isLocked ||
                                        cell.isAfterMax,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.adjustHours(cell, 1)
                                      },
                                    },
                                  },
                                  [_vm._v("+")]
                                ),
                                _c("div", { staticClass: "hours-display" }, [
                                  _c("span", { staticClass: "hours-num" }, [
                                    _vm._v(_vm._s(cell.hours)),
                                  ]),
                                ]),
                                _c(
                                  "button",
                                  {
                                    staticClass: "hour-btn decrease",
                                    attrs: {
                                      type: "button",
                                      "aria-label": "הפחת שעות",
                                      disabled:
                                        cell.isPast ||
                                        cell.isLocked ||
                                        cell.isAfterMax,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.adjustHours(cell, -1)
                                      },
                                    },
                                  },
                                  [_vm._v("−")]
                                ),
                              ]),
                              _c("span", { staticClass: "hours-label" }, [
                                _vm._v("שעות לימוד"),
                              ]),
                            ]
                          },
                          { cell: cell }
                        ),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }